import * as React from "react";

const SvgTwitter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 22 24"
    fill="none"
    {...props}
  >
    <rect width={22} height={22} y={0.801} fill="#0C0324" rx={11} />
    <path
      fill="#fff"
      d="m5.527 6.496 4.247 5.852L5.5 17.106h.962l3.742-4.166 3.023 4.166H16.5l-4.486-6.181 3.978-4.429h-.962l-3.446 3.837L8.8 6.496zm1.414.73h1.504l6.64 9.15h-1.503z"
    />
  </svg>
);
export default SvgTwitter;
